import axiosInstance from '../config/axios.js';

const API_BASE = '/shipment-qr-status';

const appendScanFile = (formData, file) => {
  if (!(file instanceof File)) return;
  const isPdf =
    file.type === 'application/pdf' || (file.name || '').toLowerCase().endsWith('.pdf');
  formData.append(isPdf ? 'scanned_pdf' : 'scanned_image', file, file.name);
};

const appendPayload = (formData, payload = {}) => {
  Object.entries(payload).forEach(([key, value]) => {
    if (value === null || value === undefined || value === '') return;
    if (key === 'shipment_ids' && Array.isArray(value)) {
      formData.append('shipment_ids', JSON.stringify(value));
      return;
    }
    formData.append(key, value);
  });
};

const QR_UPLOAD_TIMEOUT_MS = 120000;

const shipmentQrStatusService = {
  resolveFromQr: async (fileOrShipmentId) => {
    if (fileOrShipmentId instanceof File) {
      const formData = new FormData();
      appendScanFile(formData, fileOrShipmentId);
      const response = await axiosInstance.post(`${API_BASE}/resolve`, formData, {
        headers: { 'Content-Type': undefined },
        timeout: QR_UPLOAD_TIMEOUT_MS,
      });
      return response.data;
    }

    const response = await axiosInstance.post(`${API_BASE}/resolve`, {
      shipment_id: fileOrShipmentId,
    });
    return response.data;
  },

  /** Resolve from app live QR decode (raw QR string or shipment id). */
  resolveFromQrData: async ({ qrData, shipmentId, shipmentIds } = {}) => {
    const payload = {};
    if (shipmentIds?.length) payload.shipment_ids = shipmentIds;
    else if (shipmentId) payload.shipment_id = shipmentId;
    else if (qrData) payload.qr_data = qrData;
    else throw new Error('No QR data to resolve');

    const response = await axiosInstance.post(`${API_BASE}/resolve`, payload);
    return response.data;
  },

  listTodayMlSheets: async (companyId) => {
    const response = await axiosInstance.get(`${API_BASE}/today-ml-sheets`, {
      params: companyId ? { company_id: companyId } : {},
    });
    return response.data;
  },

  dispatchToMlSheet: async ({ shipmentIds, mlSheetId }) => {
    const response = await axiosInstance.post(`${API_BASE}/dispatch`, {
      shipment_ids: shipmentIds,
      ml_sheet_id: mlSheetId,
    });
    return response.data;
  },

  updateStatusFromQr: async (payload = {}, extraFiles = {}) => {
    const deliveryImage = extraFiles.delivery_receiver_image;
    const govIdImage = extraFiles.delivery_gov_id_image;
    const hasFile = deliveryImage instanceof File || govIdImage instanceof File;

    if (hasFile) {
      const formData = new FormData();
      appendPayload(formData, payload);
      if (deliveryImage instanceof File) {
        formData.append('delivery_receiver_image', deliveryImage);
      }
      if (govIdImage instanceof File) {
        formData.append('delivery_gov_id_image', govIdImage);
      }
      const response = await axiosInstance.post(`${API_BASE}/update-status`, formData, {
        headers: { 'Content-Type': undefined },
        timeout: QR_UPLOAD_TIMEOUT_MS,
      });
      return response.data;
    }

    const response = await axiosInstance.post(`${API_BASE}/update-status`, payload);
    return response.data;
  },
};

export default shipmentQrStatusService;
